<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card
        v-if="features != null"
    >
        <v-card-title>{{features.text}} Features</v-card-title>

        <v-card-text>
            <div
                v-for="(category, cat_index) in features.categories"
                :key="'cat_'+cat_index"
            >
                <b>{{category.text}}</b>

                <ul
                    style="margin-bottom: 15px"
                >
                    <li
                        v-for="(feature, findex) in category.features"
                        :key="'feat_'+cat_index+'_'+findex"
                        v-html="feature.text"
                    >
                    </li>
                </ul>
            </div>

            <p
                v-for="(footnote, findex) in features.footnotes"
                :key="'footnote_'+findex"
                v-html="footnote"
            />


        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            features: null,
        }
    },

    methods: {

        showDialog(content_type)
        {
            if ( content_type == null ) 
            {
                this.features = null;
                return;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/integrations/features/:content_type',
            
                'params' : {
                        'content_type': content_type,
                    },
            
                'on_success': (data) => {
                        this.features = data;
                        this.dialog = true;
                        this.$forceUpdate();
                    },
            
                'on_error': 'Unable to load feature information',
            });
        },

        onOk()
        {
            this.dialog = false;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>